import { DEV } from "solid-js"
import { unwrap } from "solid-js/store"
import type { Engine } from "../../lib/core/engine/Engine.type"
import { freeze } from "../../lib/core/util/Object"
import Unexpected from "../../lib/Exception/Unexpected.class"

export default function createSharedEngineListFactory<T>() {
  const cache = new WeakMap<Engine, Array<T>>

  return (engine: Engine) => {
    if (DEV) {
      if (!engine) {
        throw new Unexpected('!engine')
      }
    }
    const unwrappedEngine = unwrap(engine)
    // console.log('unwrappedEngine', unwrappedEngine, 'engine', engine)

    let list = cache.get(unwrappedEngine)
    if (!list) {
      list = []

      function cleanupFn() {
        list!.length = 0
        if (DEV) {
          freeze(list)
        }
      }

      unwrappedEngine.gcELL().push(cleanupFn)
  
      cache.set(unwrappedEngine, list)
    }
    return list
  }
}
